import { render } from "./PastGames.vue?vue&type=template&id=25e427c5"
import script from "./PastGames.vue?vue&type=script&lang=js"
export * from "./PastGames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__